module.exports = __webpack_public_path__ + "img/2p.ad65817a.png";